import { useQuery } from "@tanstack/react-query"

import { PsyIndexQualityData } from "modules/PsychologistAccount/SettingsTab/components/PsyIndexQuality/common/interfaces"
import { httpClient } from "utils/infrastructure/httpClient"

export const PSY_QUALITY_DATA_KEY = "psy-quality-data"

function getPsyIndexQualityData() {
    return httpClient.get<PsyIndexQualityData>("psychologist/dropout-coefficient/summary")
}

export function useGetPsyIndexQualityData() {
    return useQuery(
        [PSY_QUALITY_DATA_KEY],
        async () => {
            return await getPsyIndexQualityData()
        },
        {
            refetchOnWindowFocus: false,
        }
    )
}
